// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"CMSOverrideCookie_infoContainer__sNEkq","cookieList":"CMSOverrideCookie_cookieList___6vhT","button":"CMSOverrideCookie_button__kZRYU"};